import axios from "axios";
import { supabase } from "../supabaseClient";

// CRM 2.0 registration appointment (M13). The server checks the permission,
// the who-books setting and every date; errors carry { error } text.
const base = () => `${process.env.REACT_APP_PAYMENT_LINK_URL}crm2/appointment`;
const auth = () => ({ headers: { Authorization: `Bearer ${supabase.auth.session()?.access_token}` } });
const data = (response) => response.data.data;

// Returns the ids among apIds that are CRM 2.0 bookings: { crm2: [...] }
async function getCrm2Bookings(apIds) {
  return data(await axios.post(`${base()}/crm2-bookings`, { apIds }, auth()));
}

// Returns { isCrm2, open, notOpenReason, whoBooks, staffMayBook, customerMayBook, offices, appointment, history, … }
async function getAppointment(apId) {
  return data(await axios.get(`${base()}/by-booking/${apId}`, auth()));
}

// Returns { office, minDate, days: [{ date, closedReason, halves: [{ half, capacity, left, status }] }], nextFrom }
async function getAvailability(apId, officeId, from) {
  return data(await axios.get(`${base()}/availability`, { ...auth(), params: { apId, officeId, from } }));
}

async function bookAppointment(apId, officeId, date, half) {
  return data(await axios.post(`${base()}/book`, { apId, officeId, date, half }, auth()));
}

async function rescheduleAppointment(apId, slotBookingId, officeId, date, half, reason) {
  return data(await axios.post(`${base()}/reschedule`, { apId, slotBookingId, officeId, date, half, reason }, auth()));
}

async function sendBookingReminder(apId) {
  return data(await axios.post(`${base()}/reminder`, { apId }, auth()));
}

const appointmentError = (err) => err?.response?.data?.error || err?.message || "Something went wrong";

export { getCrm2Bookings, getAppointment, getAvailability, bookAppointment, rescheduleAppointment, sendBookingReminder, appointmentError };
